module.exports = __webpack_public_path__ + "img/environment.0f1ff9cb.png";